(() => {
  if (window.bb20ShowcaseLoaded) return;
  window.bb20ShowcaseLoaded = true;
  const roots = new Set();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let queued = false;
  const clamp = n => Math.max(0, Math.min(1, n));
  const visibleItems = root => Array.from(root.querySelectorAll('[data-cm-showcase-item]')).filter(item => !item.hidden);
  const relink = root => {
    const items = visibleItems(root);
    items.forEach((item, index) => {
      item.querySelector('[data-cm-product-number]').textContent = index + 1;
      item.querySelector('[data-cm-product-total]').textContent = items.length;
      const next = item.querySelector('[data-cm-showcase-next]');
      next.hidden = !items[index + 1];
      if (items[index + 1]) next.href = `#${items[index + 1].id}`;
    });
  };
  const paint = () => {
    queued = false;
    const motion = !reduced.matches && document.body.dataset.motion !== 'off';
    roots.forEach(root => {
      if (!root.isConnected) { roots.delete(root); return; }
      const items = visibleItems(root);
      const top = parseFloat(getComputedStyle(root).getPropertyValue('--showcase-nav'));
      const viewport = window.innerHeight - top;
      items.forEach((item, index) => {
        const next = items[index + 1];
        const incoming = motion && next ? clamp((window.innerHeight - next.getBoundingClientRect().top) / viewport) : 0;
        const ownTop = item.getBoundingClientRect().top;
        const entry = motion ? clamp((ownTop - top) / viewport) : 0;
        item.style.setProperty('--chapter-scale', (1 - incoming * .055).toFixed(3));
        item.style.setProperty('--chapter-opacity', (1 - incoming * .65).toFixed(3));
        item.style.setProperty('--chapter-lift', `${(entry * 28).toFixed(1)}px`);
        item.inert = ownTop < top + 2 && incoming > .96;
      });
    });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(paint); } };
  const init = parent => {
    parent.querySelectorAll('[data-cm-showcase]').forEach(root => {
      if (roots.has(root)) return;
      roots.add(root);
      root.classList.add('is-ready');
      relink(root);
      root.querySelectorAll('[data-cm-showcase-item]').forEach(item => new MutationObserver(() => { relink(root); schedule(); }).observe(item, { attributes: true, attributeFilter: ['hidden'] }));
    });
    schedule();
  };
  const start = () => {
    init(document);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    reduced.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['data-motion'] });
    document.addEventListener('shopify:section:load', e => init(e.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
